import React from 'react';
import { RestDayMessageProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';
import RestDayIllustration from '../../assets/rest_day.svg';

export const RestDayMessage: React.FC<RestDayMessageProps> = (props) => {
  const { headline, text, children } = props;

  return (
    <div className={cx(style.restDayMessage)}>
      <div className={style.content}>
        <img src={RestDayIllustration} alt="Rest Day Illustration" />
      </div>
      <h4>
        <strong>{headline}</strong>
      </h4>
      {text && <p>{text}</p>}
      {children}
    </div>
  );
};

export default RestDayMessage;
